import kurs_link from './../../json/kurs_link.json'
import offline_info from './../../json/offline_info.json'

import { sendRequest } from "./functions";


// -- class for this course
class Kurs {
    initialized = false;

    // -- initialize kurs and get infos from backend
    async init() {
        try {
            // set courseinfos
            await this.#setCourseProperties();

            // set course-type
            this.isBigVideo = this.KursTyp === "BigVideo" ? true : false;
            this.isPdf = this.KursTyp === "PDF" ? true : false;
            this.isPowerPoint = this.KursTyp === "PowerPoint" ? true : false;

            // set course-key for localstorage
            this.kurs_key = this.VNR ? ('_' + (this.VNR).replace(' ', '_')) : (this.Referenten[0].Nachname ? ('_' + (this.Referenten[0].Nachname).replace(' ', '_')) : "_key_not_definable");

            // set amount of parts the video has
            this.partsAmount = this.isPdf ? 1 : (this.isPowerPoint ? this.slides.length : this.Video.length);

            // set wissensfragen active
            this.wissensfragenActive = (this.WissensfragenSichtbar && this.WissensfragenSichtbar !== "nein") ? true : false;

            // set qr-code-generator active
            this.qrCodeGeneratorActive = (this.QRCodeGenerator && this.QRCodeGenerator !== "nein") ? true : false;

            // set is gcp-course
            this.isGcp = (this.GCP && this.GCP !== "nein") ? true : false;

            // set is course certified
            this.isCertified = (this.Zertifiziert && this.Zertifiziert !== "nein") ? true : false;

            // set all slides
            this.allSlides = this.#getAllSlides();


            // set course active/inactive
            const start = new Date(new Date(this.Laufzeit_Start).toDateString());
            const end = new Date(new Date(this.Laufzeit_Ende).toDateString());
            const today = new Date(new Date().toDateString());

            // active
            if (today >= start && today <= end) this.active = true;
            // inactive
            else this.active = false;


            // set initialized
            this.initialized = true;

            console.log('%cKurs erfolgreich geladen', 'color: #00ff00');
        }
        catch (e) {
            // if something failes dont let course be initialized
            console.log('%cFehler beim Initialisieren des Kurses', 'color: #ff0000', e);
            this.initialized = false;
        }
    }


    // -- get-request to backend -> set responste to course-properties
    async #setCourseProperties() {

        let courseObject;

        // send request for course to backend
        const response = await sendRequest('GET', `/kurse/${kurs_link.KursKey}`);

        // if backend response with course-information -> set it
        if (response.success) courseObject = response.data;
        // if something went wrong while fetching (e.g. no internet) -> use offline-json-file
        else courseObject = offline_info;

        // set this courses propertys
        for (let key in courseObject) {
            this[key] = courseObject[key];
        }
    }

    // -- set slide-times
    #getAllSlides = () => {
        var result = [];

        // -- get slides if is not a bigVideo
        if (!this.isBigVideo && !this.isPdf) {

            for (let i = 0; i < this.slides.length; i++) {
                // -- current course-part
                const thisPart = this.slides[i];

                for (let j = 0; j < thisPart.length; j++) {
                    // -- current slide
                    const thisSlide = thisPart[j];
                    const nextSlide = thisPart[j + 1];

                    // dont set a time if course is powerpoint
                    if (this.isPowerPoint) thisSlide.time = null;

                    // set start- and enttime for this slide
                    else {
                        // convert minutes.seconds to seconds
                        const starttime = thisSlide.time.split(':');
                        thisSlide.starttime = parseInt(starttime[0]) * 60 + parseInt(starttime[1]);

                        // add endtime to slides array ( last slide endtime is set in mainVideo.init )
                        const lastSlideMessage = "defined after video meta is loaded"
                        const endtime = (nextSlide) ? nextSlide.time.split(':') : lastSlideMessage;
                        thisSlide.endtime = parseInt(endtime[0]) * 60 + parseInt(endtime[1]);

                        // error handling
                        if (parseInt(starttime[1]) >= 60 || starttime.length !== 2 || ((parseInt(endtime[1]) >= 60 || endtime.length !== 2) && endtime !== lastSlideMessage)) {
                            throw "FEHLER BEI ZEITFORMAT";
                        }
                    }

                    // set image-source for this slide
                    thisSlide.source = `${process.env.PUBLIC_URL}/assets/charts/part_0${i + 1}/Folie${((j + 1) >= 10) ? (j + 1) : ('0' + (j + 1))}${thisSlide.videoPoster ? ".mp4" : ".png"}`
                }
                result.push(thisPart);
            }
        }

        return result;
    }
}


// -- Kurs
const cme_kurs = new Kurs();

export { cme_kurs }